import { MinusIcon } from '@heroicons/react/20/solid';
import { Para, Stack } from 'ui-components';
import { formattedDuration } from 'ui-format-utils';

type Props = {
  title: string;
  time?: number;
  className?: string;
};
export default function TimeDisplay({ title, time, className }: Props): React.ReactElement {
  return (
    <Stack className="items-center">
      <Para size="sm" className="text-zinc-600">
        {title}
      </Para>

      <Para weight="bold" className={className}>
        {time ? (
          formattedDuration(time, { hours: true, showZero: true })
        ) : (
          <MinusIcon className="w-6 h-6 opacity-40" />
        )}
      </Para>
    </Stack>
  );
}
